import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getMiniGames } from "../../redux/actions/casino";
import { RESET_GAMES_STATE } from "../../redux/types";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/opacity.css";
import Zippelin from "../../assets/images/zippelin.webp";

const GamesList = ({ setOpenLogin }) => {
  const dispatch = useDispatch();
  const { games, loading } = useSelector((state) => state.casino);
  useEffect(() => {
    dispatch(getMiniGames());

    return () => {
      dispatch({ type: RESET_GAMES_STATE });
    };
  }, []);
  const placeholderImage =
    "https://img.freepik.com/premium-vector/casino-mascot-logo-esport-template_142989-365.jpg?w=2000";

  const token =
    localStorage.getItem("token") !== undefined &&
    localStorage.getItem("token") !== null
      ? localStorage.getItem("token")
      : null;
  const onImageError = (e) => {
    e.target.src = placeholderImage;
  };
  return (
    <div className="row row-game-listing mt-5 mr-0 ml-0">
      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: {
                  identifier: "pragmaticexternal:BigBassCrash",
                  gapi: false,
                },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/BigBassCrash.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/BigBassCrash.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Big Bass Crash</a>
            </p>
          </div>
        </div>
      </Link>

      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: { identifier: "pragmaticexternal:Spaceman", gapi: false },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/Spaceman.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/Spaceman.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Spaceman</a>
            </p>
          </div>
        </div>
      </Link>
      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: { identifier: "pragmaticexternal:Chicken", gapi: false },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/Chicken.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/Chicken.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Chicken</a>
            </p>
          </div>
        </div>
      </Link>
      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: {
                  identifier: "pragmaticexternal:HighFlyer",
                  gapi: false,
                },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/HighFlyer.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/HighFlyer.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">High Flyer</a>
            </p>
          </div>
        </div>
      </Link>
      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: { identifier: "pragmaticexternal:Limbo", gapi: false },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/Limbo.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/Limbo.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Limbo+</a>
            </p>
          </div>
        </div>
      </Link>

      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: { identifier: "pragmaticexternal:Spire", gapi: false },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/Spire.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/Spire.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Spire+</a>
            </p>
          </div>
        </div>
      </Link>
      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: { identifier: "pragmaticexternal:Plinko", gapi: false },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/Plinko.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/pragmaticexternal/Plinko.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Plinko+</a>
            </p>
          </div>
        </div>
      </Link>

      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: { identifier: "gameart:YellowDiver", gapi: false },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/gameart/YellowDiver.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/gameart/YellowDiver.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Yellow Diver</a>
            </p>
          </div>
        </div>
      </Link>

      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: { identifier: "kalamba:BalloonOdysseyCrash_k", gapi: false },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/kalamba/BalloonOdysseyCrash_k.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/kalamba/BalloonOdysseyCrash_k.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Balloon Odyssey Crash</a>
            </p>
          </div>
        </div>
      </Link>


      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: { identifier: "fugaso:MagnifyMan", gapi: false },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/fugaso/MagnifyMan.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/fugaso/MagnifyMan.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Magnify Man</a>
            </p>
          </div>
        </div>
      </Link>

      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: { identifier: "spribe:aviator", gapi: false },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/spribe/aviator.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/spribe/aviator.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Aviator</a>
            </p>
          </div>
        </div>
      </Link>

      <Link
        to={token ? "/open" : ""}
        state={
          token
            ? {
                item: { identifier: "softswiss:SpaceXY", gapi: false },
                type: "casino",
                from: "/mini-games",
              }
            : {}
        }
        className="col-xl-3 col-lg-4 col-6"
      >
        <div className="item-game">
          <figure className="item-game-thumb">
            <span>
              <LazyLoadImage
                className="LazyLoad"
                effect="blur"
                src={
                  "https://cdn.zmsfnxxx.xyz/i/s3/softswiss/SpaceXY.png"
                }
                onError={onImageError}
                placeholderSrc={
                  "https://cdn.zmsfnxxx.xyz/i/s3/softswiss/SpaceXY.png"
                }
              />
            </span>
            <span title="Play Now" className="btn btn-primary item-game-launch">
              <span>Play Now</span>
            </span>
          </figure>{" "}
          <div className="item-game-desc">
            <p className="item-game-title">
              <a href="#">Space XY</a>
            </p>
          </div>
        </div>
      </Link>



      
      {games !== null &&
        games.precoins?.length > 0 &&
        games.precoins?.map((item, idx) => (
          <Link
            to={token ? "/open" : ""}
            state={
              token ? { item: item, type: "precoins", from: "/mini-games" } : {}
            }
            key={idx.toString()}
            className="col-xl-3 col-lg-4 col-6"
          >
            <div className="item-game">
              <figure className="item-game-thumb">
                <span>
                  <LazyLoadImage
                    className="LazyLoad"
                    effect="blur"
                    src={item.iconUrl}
                    onError={onImageError}
                    alt={item.name}
                    placeholderSrc={item.iconUrl}
                  />
                </span>
                <a
                  href="#"
                  title="Play Now"
                  className="btn btn-primary item-game-launch"
                >
                  <span
                    onClick={() => {
                      if (!token) {
                        setOpenLogin(true);
                      }
                    }}
                  >
                    {!token && "Login &"} Play Now{" "}
                  </span>
                </a>
              </figure>{" "}
              <div className="item-game-desc">
                <p className="item-game-title">
                  <a href="#">{item.name}</a>
                </p>
              </div>
            </div>
          </Link>
        ))}

      {games !== null &&
        games.fiable?.length > 0 &&
        games.fiable?.map((itemF, idx) => (
          <Link
            to={token ? "/open" : ""}
            state={
              token ? { item: itemF, type: "fiable", from: "/mini-games" } : {}
            }
            key={idx.toString()}
            className="col-xl-3 col-lg-4 col-6"
          >
            <div className="item-game">
              <figure className="item-game-thumb">
                <span>
                  <LazyLoadImage
                    className="LazyLoad"
                    effect="blur"
                    src={itemF.image_name}
                    onError={onImageError}
                    alt={itemF.name}
                    placeholderSrc={itemF.image_name}
                  />
                </span>
                <a
                  href="#"
                  title="Play Now"
                  className="btn btn-primary item-game-launch"
                >
                  <span
                    onClick={() => {
                      if (!token) {
                        setOpenLogin(true);
                      }
                    }}
                  >
                    {!token && "Login &"} Play Now{" "}
                  </span>
                </a>
              </figure>{" "}
              <div className="item-game-desc">
                <p className="item-game-title">
                  <a href="#">{itemF.name}</a>
                </p>
              </div>
            </div>
          </Link>
        ))}
    </div>
  );
};
export default GamesList;
